__turbopack_context__.v({
  "className": "uwCoHW_className",
  "variable": "uwCoHW_variable",
});
